<div class="card h-100">
  <div class="card-body">
    <div class="d-flex gap-4 justify-content-between align-items-center mb-2">
      <h5 class="card-title mb-0">
        Detected Threat Status
        <span
          kendoTooltip
          class="info-icon"
          title="Status of reported malicious or potentially malicious files."
        >
          <kendo-svg-icon [icon]="infoCircleIcon"></kendo-svg-icon>
        </span>
      </h5>
      <kendo-dropdownbutton
        kendoButton
        [svgIcon]="moreVerticalIcon"
        fillMode="flat"
        size="small"
        [data]="[{ text: 'View Data' }]"
        (itemClick)="onViewData()"
      ></kendo-dropdownbutton>
    </div>

    <div class="chart-container">
      @if (isLoading()) {
        <kendo-skeleton
          shape="rectangle"
          animation="wave"
          width="100%"
          height="320px"
        ></kendo-skeleton>
      } @else if (threatStatus().length > 0) {
        <div
          echarts
          [options]="chartOptions()"
          [initOpts]="{ renderer: 'canvas' }"
          style="height: 320px; width: 100%"
        ></div>
      } @else {
        <h1>No Data</h1>
      }
    </div>
  </div>
</div>
@if (showPopup()) {
  <kendo-dialog
    (close)="close()"
    [width]="'95vw'"
    [height]="'90vh'"
    [minWidth]="'800px'"
    [maxWidth]="'1400px'"
  >
    <kendo-dialog-titlebar>{{ modalTitle() }}</kendo-dialog-titlebar>

    <div class="d-flex justify-content-start mb-2">
      <button
        type="button"
        kendoButton
        class="cyflare-btn-secondary"
        [disabled]="isExporting()"
        (click)="exportCsv()"
      >
        Download CSV
      </button>
    </div>

    @if (datatableUrl(); as url) {
      <div class="table-responsive w-100">
        <app-datatable
          [data-href]="url"
          [columns]="datatableColumns"
          [useOData]="true"
          [initialFilters]="odataFilters()"
        ></app-datatable>
      </div>
    }
  </kendo-dialog>
}
